import(/* webpackMode: "eager" */ "/usr/src/app/privacy/cookies/page.js");
